/// <reference types="./order-by-parser.d.ts" />
import { OrderByItemNode } from '../operation-node/order-by-item-node.js';
import { RawNode } from '../operation-node/raw-node.js';
import { parseReferenceExpression, } from './reference-parser.js';
export function parseOrderBy(orderBy, direction) {
    return OrderByItemNode.create(parseOrderByExpression(orderBy), parseOrderByDirectionExpression(direction));
}
function parseOrderByExpression(expr) {
    return parseReferenceExpression(expr);
}
function parseOrderByDirectionExpression(expr) {
    if (!expr) {
        return undefined;
    }
    if (expr === 'asc' || expr === 'desc') {
        return RawNode.createWithSql(expr);
    }
    else {
        return expr.toOperationNode();
    }
}
